var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.345 16.6666C17.6434 16.6666 17.9173 16.5 18.0608 16.2325C18.2035 15.965 18.1921 15.6391 18.0307 15.3825L10.6926 3.71581C10.5426 3.47748 10.2841 3.33331 10.0069 3.33331C9.7297 3.33331 9.47124 3.47748 9.32122 3.71581L1.98318 15.3825C1.82174 15.6391 1.81033 15.965 1.95301 16.2325C2.09651 16.5 2.37046 16.6666 2.66888 16.6666H17.345Z",
    fill: "url(#paint0_linear_16635_35492)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0072 13.3334C10.4573 13.3334 10.8226 13.7067 10.8226 14.1667C10.8226 14.6267 10.4573 15 10.0072 15C9.55717 15 9.19189 14.6267 9.19189 14.1667C9.19189 13.7067 9.55717 13.3334 10.0072 13.3334ZM9.19189 10V11.6667C9.19189 12.1267 9.55717 12.5 10.0072 12.5C10.4573 12.5 10.8226 12.1267 10.8226 11.6667V10C10.8226 9.54002 10.4573 9.16669 10.0072 9.16669C9.55717 9.16669 9.19189 9.54002 9.19189 10Z",
    fill: "#FFB300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0072 14.1667C10.4575 14.1667 10.8226 13.7936 10.8226 13.3333C10.8226 12.8731 10.4575 12.5 10.0072 12.5C9.55693 12.5 9.19189 12.8731 9.19189 13.3333C9.19189 13.7936 9.55693 14.1667 10.0072 14.1667Z",
    fill: "url(#paint1_linear_16635_35492)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19189 9.16671V10.8334C9.19189 11.2934 9.55717 11.6667 10.0072 11.6667C10.4573 11.6667 10.8226 11.2934 10.8226 10.8334V9.16671C10.8226 8.70671 10.4573 8.33337 10.0072 8.33337C9.55717 8.33337 9.19189 8.70671 9.19189 9.16671Z",
    fill: "url(#paint2_linear_16635_35492)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16635_35492",
    x1: 7.14182,
    y1: 15.8841,
    x2: 11.9597,
    y2: 3.60621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#FBC02D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16635_35492",
    x1: 9.81481,
    y1: 13.6875,
    x2: 10.3062,
    y2: 12.0592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16635_35492",
    x1: 9.71045,
    y1: 11.4108,
    x2: 10.638,
    y2: 8.36857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFDE7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/Caution.cde1a6c83f2d4e18d5e85f9ed65b3c40.svg";
export { ForwardRef as ReactComponent };